<template>
    <div class="brief-list-page">
        <div class="brief-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">项目简报</span>
            </div>

            <div class="panel">
                <div class="panel-hd">
                    <h2>周报列表</h2>
                    <div class="toolbar">
                        <label class="search-box">
                            <i class="el-icon-search"></i>
                            <input
                                v-model.trim="keyword"
                                type="search"
                                placeholder="搜索周报标题"
                            />
                        </label>
                    </div>
                </div>

                <div class="list-rows" v-loading="loading">
                    <a
                        v-for="item in filteredList"
                        :key="item.id || item.identifier"
                        href="javascript:;"
                        class="list-row"
                        @click.prevent="goPreview(item)"
                    >
                        <span class="list-date">{{ formatDate(item.createTime) }}</span>
                        <div class="list-main">
                            <div class="list-title">{{ item.name }}</div>
                        </div>
                        <i class="el-icon-arrow-right row-arrow"></i>
                    </a>

                    <ph-empty
                        v-if="!loading && filteredList.length === 0"
                        size="page"
                        :text="keyword ? '未找到匹配的周报' : '暂无周报'"
                        :subtext="keyword ? '请尝试更换搜索关键词' : ''"
                    />
                </div>

                <div class="pager-wrap" v-if="pages.total > 0 && !keyword">
                    <pagination
                        :total="pages.total"
                        :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize"
                        @pagination="handlePageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeBriefList',
    components: { pagination, PhEmpty },
    data() {
        return {
            loading: false,
            keyword: '',
            tableData: [],
            pages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
        filteredList() {
            if (!this.keyword) return this.tableData
            const key = this.keyword.toLowerCase()
            return this.tableData.filter(item =>
                (item.name || '').toLowerCase().includes(key)
            )
        }
    },
    methods: {
        formatDate(val) {
            if (!val) return '--'
            return dayjs(val).format('YYYY-MM-DD')
        },
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        goPreview(item) {
            if (!item.identifier) {
                this.$message.error('暂无内容')
                return
            }
            this.$router.push({
                path: `/projectHome/${this.projectId}/brief/preview`,
                query: {
                    identifier: item.identifier,
                    name: item.name || '',
                    date: this.formatDate(item.createTime),
                    from: 'list'
                }
            })
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.keyword = ''
            this.fetchList()
        },
        async fetchList() {
            if (!this.projectId) {
                this.tableData = []
                this.pages.total = 0
                return
            }
            this.loading = true
            try {
                const res = await this.$Api.Project.getProjectBriefing({
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize
                })
                const data = (res && res.data) || {}
                this.tableData = data.records || []
                this.pages.total = data.total || 0
            } catch (e) {
                this.tableData = []
                this.pages.total = 0
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        this.fetchList()
    }
}
</script>

<style lang="less" scoped>
.brief-list-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.brief-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
}

.panel-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 24px;
    line-height: 56px;
    border-bottom: 1px solid rgba(199, 199, 199, 0.4);
    background: rgba(250, 251, 255, 1);

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #333;
    }
}

.toolbar {
    display: flex;
    align-items: center;
}

.search-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    border: 1px solid #e0e6ed;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;

    i {
        color: #999;
        font-size: 14px;
    }

    input {
        border: none;
        outline: none;
        width: 180px;
        font-size: 13px;
        color: #333;
        background: transparent;
        font-family: inherit;

        &::placeholder {
            color: #bbb;
        }
    }
}

.list-rows {
    min-height: 240px;
}

.list-row {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 18px 24px;
    border-bottom: 1px solid #f0f3f7;
    text-decoration: none;
    color: inherit;
    transition: background 0.2s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #EAF6FF;

        .list-title {
            color: #01A2FD;
        }

        .row-arrow {
            color: #01A2FD;
        }
    }
}

.list-date {
    flex-shrink: 0;
    width: 96px;
    font-size: 13px;
    color: #999;
}

.list-main {
    flex: 1;
    min-width: 0;
}

.list-title {
    font-size: 15px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.row-arrow {
    flex-shrink: 0;
    color: #ccc;
    font-size: 14px;
}

.pager-wrap {
    padding: 8px 16px 16px;
}

@media screen and (min-width: 1250px) {
    .brief-wrap {
        width: 1200px;
    }
}
</style>
